module.exports = __webpack_public_path__ + "static/media/screens.1921a021.png";